import React from 'react';
import { FabricaTabs } from '../components/FabricaTabs';
import ListarSectores from '../components/insumos/sectores/ListarSectores';
import ListarEquipos from '../components/insumos/equipos/ListarEquipos';
import ListarMotores from '../components/insumos/motores/ListarMotores';
import { theme } from '../theme';

const FabricaPage: React.FC = () => {
  return (
    <div style={{ padding: '0' }}>
      {/* Título de la página */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ 
          fontSize: theme.fontSizes.xxlarge,
          fontWeight: 600,
          color: theme.colors.primaryDark,
          margin: 0
        }}>
          Gestión de Fábrica
        </h1>
        <p style={{
          color: theme.colors.textSecondary,
          marginTop: '8px',
          fontSize: theme.fontSizes.normal
        }}>
          Administración de sectores, equipos y motores de la fábrica
        </p>
      </div>

      {/* Tabs con los componentes existentes */}
      <FabricaTabs
        sectoresComponent={<ListarSectores />}
        equiposComponent={<ListarEquipos />}
        motoresComponent={<ListarMotores />}
      />
    </div>
  );
};

export default FabricaPage;

